import { axiosPrivate } from "../api/axios";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";
import moment from "moment";
import AuthService from "../service/AuthSerivce";

export function useAxiosPrivate() {
	const refresh = useRefreshToken();
	const { auth } = useAuth();

	useEffect(() => {
		const requestIntercept = axiosPrivate.interceptors.request.use(
			async (config) => {
				//IF TOKEN IS IN LAST 50% OF IT'S DURATION REFRESH TOKEN WITH THE NEXT REQUEST
				const tokenCreateDate = moment(auth?.date);
				const tokenExpiryDate = tokenCreateDate.add(auth?.ttl / 2, "s");
				const now = moment();
				if (auth && auth?.date && auth?.ttl && tokenExpiryDate < now) {
					const response = await refresh(auth);
					if (!(response.status > 199 && response.status < 300)) AuthService.logout();
				}

				//ATTACH HEADERS FOR AUTH
				if (!config.headers["Authorization"]) {
					if (auth?.token) {
						config.headers["Authorization"] = `Bearer ${auth.token}`;
					} else {
						if (localStorage.getItem("user")) {
							const user = JSON.parse(localStorage.getItem("user"));
							config.headers["Authorization"] = `Bearer ${user.token}`;
						}
					}
				}
				return config;
			},
			(error) => Promise.reject(error)
		);

		const responseIntercept = axiosPrivate.interceptors.response.use(
			(response) => response,
			async (error) => {
				//IF ANY REQUEST RECEIVES RESPONSE STATUS 401 USER WILL BE LOGGED OUT
				const user = JSON.parse(localStorage.getItem("user"));
				if (error?.response?.status === 401 && (auth.token || user)) {
					AuthService.logout();
				}
				return Promise.reject(error);
			}
		);

		return () => {
			axiosPrivate.interceptors.request.eject(requestIntercept);
			axiosPrivate.interceptors.response.eject(responseIntercept);
		};
	}, [auth, refresh]);

	return { axiosPrivate, auth };
}

export default useAxiosPrivate;
